import Vue from "vue";

export default {
	state: {
		actors: [],
		actorsWithInactive: [],
		actorPagination: {},
		actorDetails: {}
	},

	mutations: {
		setWorkflowActorsOnState(state, actors) {
			state.actors = actors;
			state.actorsWithInactive = actors;
		},
		setActorPaginationOnState(state, actorPagination) {
			state.actorPagination = actorPagination;
		},
		cleanWorkflowUsersActors(state, actors) {
			state.actors = actors;
			state.actorsWithInactive = actors;
		},
		setActorDetailsOnState(state, actorDetail) {
			state.actorDetails = actorDetail;
		}
	},

	actions: {
		editActor(_, actor) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("Actor/" + actor.id, actor)
					.then((response) => {
						this.state.loading = false;
						response.data.isError ? reject(response.data.data) : resolve();
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		createActor(_, actor) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("Actor", actor)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		getActors({ commit }, actorData = {}) {
			const { isIframeContext = false } = actorData;
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("Actor", {}, { isIframeContext }).then((response) => {
					this.state.loading = false;
					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}
					commit("setWorkflowActorsOnState", response.data.data);
					resolve(response.data.data);
				});
			});
		},
		getActorsWithPagination({ commit }, pagination) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("Actor/pagination", pagination).then((response) => {
					this.state.loading = false;
					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}
					commit("setWorkflowActorsOnState", response.data.data.list);
					commit("setActorPaginationOnState", response.data.data.pagination);
					resolve(response.data.data.pagination);
				});
			});
		},
		getActorById({ commit }, id) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("Actor/" + id)
					.then((response) => {
						this.state.loading = false;
						if (response.error) {
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						commit("setActorDetailsOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getActorsIncludeSupplier({ commit }) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("Actor/all").then((response) => {
					this.state.loading = false;
					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}
					commit("setWorkflowActorsOnState", response.data.data);
					resolve(response.data.data);
				});
			});
		}
	},

	getters: {
		actors({ actors }) {
			return actors;
		},
		actorsWithInactive({ actorsWithInactive }) {
			return actorsWithInactive;
		},
		actorPagination({ actorPagination }) {
			return actorPagination;
		},
		actorDetails({ actorDetails }) {
			return actorDetails;
		}
	}
};
